import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import BaseAPI from '../../api/apiurl';

const ApexChatSPover = () => {
  const [userData, setUserData] = useState([]);
  const [chartData, setChartData] = useState({
    series: [
      {
        name: 'Number of Locations',
        group: 'budget',
        data: [],
      },
      {
        name: 'Number of Service Products',
        group: 'actual',
        data: [],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
          },
        },
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true,
        },
      },
      xaxis: {
        categories: [],
      },
      dataLabels: {
        enabled: false, // Set this to false to disable numeric values display
      },
    },
  });

  const Dashboardcount = () => {
    console.log('Dashboardcount function executed');
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');

    if (company_id && customer_id) {
      const apiUrl = `${BaseAPI}overallproductchart?company_id=${company_id}&customer_id=${customer_id}`;

      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error('Failed to fetch data');
          }
        })
        .then((data) => {
          setUserData(data.data);

          const locationData = data.data.map((user) => user.location);
          const serviceProductsData = data.data.map((user) => user.serviceproducts);

          console.log("00001" , serviceProductsData);
          setChartData((prevChartState) => ({
            ...prevChartState,
            series: [
              {
                ...prevChartState.series[0],
                data: locationData,
                dataLabels: {
                  enabled: false, 
                },
              },
              {
                ...prevChartState.series[1],
                data: serviceProductsData,
                
              },
            ],
            options: {
              ...prevChartState.options,
              xaxis: {
                categories: data.data.map((user) => user.productname),
              },
            },
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log('company_id and customer_id not found in local storage');
    }
  };

  useEffect(() => {
    Dashboardcount();
  }, []);

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={350} />
      </div>
    </div>
  );
};

export default ApexChatSPover;
